import { generateTable } from '../../table/Table';
import { fetchSources } from '../../../apis';
import { defineFilter } from '../../../helpers';
import { fetchSourceAdapters } from '../../../apis/task';
var clientSide = defineFilter(true).startsWith('name', 'name').equals('type', 'type').end();

var filterDataSources = function filterDataSources() {
  return {
    sourceTypes: {
      fn: fetchSourceAdapters,
      params: [],
      transform: function transform(result) {
        return result.sourceAdapters.map(function (st) {
          return {
            label: st.name,
            value: st.name
          };
        });
      }
    }
  };
};

var dataSource = function dataSource() {
  return {
    fn: fetchSources,
    params: function params() {
      return [{
        include: 'details'
      }];
    },
    transform: function transform(result) {
      return {
        data: result.sources
      };
    },
    clientSide: clientSide
  };
};

var filters = function filters() {
  return function (_ref) {
    var sourceTypes = _ref.sourceTypes;
    return sourceTypes && [{
      name: 'name',
      label: 'Name',
      type: 'text'
    }, {
      name: 'type',
      label: 'Type',
      type: 'select',
      options: sourceTypes
    }];
  };
};

var columns = [{
  title: 'ID',
  value: 'id'
}, {
  title: 'Name',
  value: 'name'
}, {
  title: 'Type',
  value: 'type'
}, {
  title: 'Created',
  value: 'createdAt'
}, {
  title: 'Created By',
  value: 'createdBy'
}, {
  title: 'Updated',
  value: 'updatedAt'
}, {
  title: 'Updated By',
  value: 'updatedBy'
}];
export var SourceTable = generateTable({
  columns: columns,
  filters: filters,
  filterDataSources: filterDataSources,
  dataSource: dataSource
});
SourceTable.displayName = 'SourceTable';